$(document).ready(function() {
    setInterval(function() {
        $('#cartLink').load(location.href + ' #cartLink > *');
    }, 5000); 
    $('.add-to-cart').click(function(e) {
        e.preventDefault();
        $('#cartLink').load(location.href + ' #cartLink > *');
    });
    $('#main_nav>li>a:contains("Shop by category")').attr('href', 'javascript:void(0)');
    $('#main_nav>li>a:contains("Upto 40% off")').attr('href', 'javascript:void(0)');
    $('#main_nav>li>a:contains("Shop by Age")').attr('href', 'javascript:void(0)');
    if (window.location.href.includes("/pages/herbal-chocovita")) {
      window.location.href = "https://www.babyorgano.com/products/nutriverse-chocolate-milk-mix";
    };
    if (window.location.href === "https://www.babyorgano.com/products") {
        window.location.href = "https://www.babyorgano.com/collections/shop";
      };
    if (window.location.href === "https://www.babyorgano.com/collections") {
        window.location.href = "https://www.babyorgano.com/collections/shop";
      };
      $('#mobNav li#reward').on('click', function() {
          $('.flits-reward-button').trigger('click');
      });
      $('#support-icon').on('click', function() {
        $('.smart-bot-container > div').trigger('click');
      });

var checkExist = setInterval(function() {
    if ($('.rapi-bundles__bars input[type="radio"]').length > 0) {
      clearInterval(checkExist);

      // Now bind the event
      $('.rapi-bundles__bars input[type="radio"]').change(function() {
        var labelText = $(this).next('label').find('.rapi-bundles__bar-title').text().trim();
        var quantity = 1; // default fallback
        var match = labelText.match(/Buy\s*(\d+)/i);
        if (match && match[1]) {
          quantity = parseInt(match[1]);
        }
        $('#stquantity').val(quantity);
      });

      // Optional: trigger it on page load to set correct initial value
      $('.rapi-bundles__bars input[type="radio"]:checked').trigger('change');
    }
  }, 1000); // check every 300ms
  
});
jQuery(document).ready(function($) {
       $('.ingredients-block-withloop').owlCarousel({
            loop:true,
            autoplay:true,
            autoplayTimeout:5000,
            margin:30,
            singleItem:true,
            nav:false,
            dots:true,
            items:3,
            touchDrag  : true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    navText: ["&#8249;","&#8250;"],
                },
                767:{
                    items:2
                },
                991:{
                    items:3
                }
            }
        });

  $('.ingredients-block-withoutloop').owlCarousel({
            loop:false,
            autoplay:true,
            autoplayTimeout:5000,
            margin:30,
            singleItem:true,
            nav:false,
            dots:true,
            items:3,
            touchDrag  : true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    navText: ["&#8249;","&#8250;"],
                },
                767:{
                    items:2
                },
                991:{
                    items:3
                }
            }
        });
  });

jQuery(document).ready(function ($) {
       $('.testimonials-carousel').owlCarousel({
            loop:true,
            autoplay:true,
            autoplayTimeout:5000,
            margin:30,
            singleItem:true,
            nav:false,
            dots:true,
            items:3,
            touchDrag  : true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    navText: ["&#8249;","&#8250;"],
                },
                767:{
                    items:2
                },
                991:{
                    items:3
                }
            }
        });
  });

jQuery(document).ready(function ($) {
       $('.landingbenefits-carousel').owlCarousel({
            loop:true,
            autoplay:true,
            autoplayTimeout:8000,
            margin:20,
            singleItem:true,
            nav:false,
            dots:true,
            items:3,
            touchDrag: true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    navText: ["&#8249;","&#8250;"],
                },
                767:{
                    items:2
                },
                991:{
                    items:3
                }
            }
        });
   $('.productimage-carousel').owlCarousel({
          loop:false,
          autoplay:true,
          autoplayTimeout:5000,
          margin:30,
          singleItem:true,
          nav:false,
          dots:false,
          items:4,
          touchDrag  : true,
          responsive:{
              0:{
                  items:1
              },
              767:{
                  items:4
              }
          }
      });
   $('.landingimage-carousel-review').owlCarousel({
          loop:false,
          autoplay:true,
          autoplayTimeout:5000,
          margin:30,
          singleItem:true,
          nav:false,
          dots:true,
          items:2,
          touchDrag  : true,
          responsive:{
              0:{
                  items:1
              },
              767:{
                  items:1
              },
            900:{
              items:2
            }
          }
      });
      if ($('.psm-content.has-multiple-images').length) {
        $('.psm-content').owlCarousel({
          loop: true,
          autoplay: true,
          autoplayTimeout: 7000,
          margin: 0,
          singleItem: true,
          nav: false,
          dots: true,
          items: 1,
          touchDrag: true,
        });
      };
  });
jQuery(document).ready(function(){
 jQuery('.video-play').magnificPopup({
		disableOn: 100,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});
  jQuery(".show_hide") .on("click", function () {
        if ( jQuery(".show_hide").hasClass("opened")) {
          jQuery(".show_hide").removeClass('opened');
          jQuery(".homebottom-content.collectionpage").css("max-height", "100px");
          jQuery(".show_hide").text('Read More');
        } else {
          jQuery(".show_hide").addClass('opened');
          jQuery(".homebottom-content.collectionpage").css("max-height", "inherit");
          jQuery(".show_hide").text('Read Less');
        }
    });
});

jQuery(document).ready(function ($) {
       $('.landingimage-carousel').owlCarousel({
            loop:true,
            autoplay:true,
            autoplayTimeout:5000,
            margin:30,
            singleItem:false,
            nav:false,
            dots:true,
            items:5,
            touchDrag  : true,
            responsive:{
                0:{
                    items:1,
                    nav:false,
                    navText: ["&#8249;","&#8250;"],
                },
                767:{
                    items:3
                },
                991:{
                    items:5
                }
            }
        });
  });
$(document).ready(function() {
  function toggleMobileSlider() {
    const isSliderEnabled = $('#mobile-slider').data('slider-enabled');

    if (isSliderEnabled && $(window).width() < 750) {
      $('#mobile-slider')
        .addClass('mobile-slider-icon-text owl-carousel')
        .owlCarousel({
          loop: true,
          autoplay: true,
          autoplayTimeout: 7000,
          margin: 0,
          nav: false,
          dots: false,
          items: 1,
          touchDrag: true,
        });
    } else {
      $('#mobile-slider')
        .trigger('destroy.owl.carousel')
        .removeClass('mobile-slider-icon-text owl-carousel');
    }
  }

  toggleMobileSlider();
  $(window).resize(toggleMobileSlider);  
  
});

$(document).ready(function () {
    function toggleBackScroll() {
        const popConvertApp = document.getElementById('pop-convert-app');
        if (popConvertApp && popConvertApp.shadowRoot) {
            const modalBackdrop = popConvertApp.shadowRoot.querySelector('.modal-backdrop');
            if (modalBackdrop) {
                $("body").addClass("back-scroll");
            } else {
                $("body").removeClass("back-scroll");
            }
        } else {
            $("body").removeClass("back-scroll");
        }
    }
    toggleBackScroll();
    setInterval(toggleBackScroll, 500);


  setTimeout(function () {
      var firstBar = $(".rapi-bundles__bar").first();
      if (firstBar.find(".rapi-bundles__bar-full-price").length === 0) {
          var fullPriceElement = $(".rapi-bundles__bar")
              .not(firstBar)
              .find(".rapi-bundles__bar-full-price")
              .first();
          if (fullPriceElement.length > 0) {
              var clonedFullPrice = fullPriceElement.clone();
              firstBar.find(".rapi-bundles__bar-pricing-column").append(clonedFullPrice);
          }
      }
  }, 2000); 


function toggleDisabledClass() {
    var $variationButton = $('.variationproduct .product-form__submit');
    var $mainButton = $('.product-form__submit'); // main product form button
    var isDisabled;

    if ($variationButton.length > 0) {
        // Product has variants
        isDisabled = $variationButton.is(':disabled');
    } else {
        // No variants; check main button
        isDisabled = $mainButton.is(':disabled');
    }

    // Update sticky Add to Cart button state
    $('.stickyCart .stAddtocart_js').prop('disabled', isDisabled);

    // Update Add to Cart button text
    if (isDisabled) {
        $('.stickyCart .btnin').text("Sold Out");
        $('.stickyCart .shopify-payment-button').addClass('disabled');
    } else {
        $('.stickyCart .btnin').text("Add to cart");
        $('.stickyCart .shopify-payment-button').removeClass('disabled');
    }
}

$(document).ready(function () {
    toggleDisabledClass();
});

$(document).on('change', 'input[type=radio], select', function () {
    setTimeout(toggleDisabledClass, 100);
});


  
});






/* function createCookie(cookieName,cookieValue,daysToExpire) {
		var date = new Date();
		date.setTime(date.getTime()+(daysToExpire*24*60*60*1000));
		document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString() + ";path=/";
	}
	function accessCookie(cookieName) {
		var name = cookieName + "=";
		var allCookieArray = document.cookie.split(';');
		for(var i=0; i<allCookieArray.length; i++)  {
			var temp = allCookieArray[i].trim();
			if (temp.indexOf(name)==0)
			return temp.substring(name.length,temp.length);
	  }
		return "";
	}
	var user = accessCookie("offerpopup");
	if (user!=""){
	  //console.log(document.cookie);
	} else {
		setTimeout(function(){ 
			jQuery.magnificPopup.open({
			  items: {
				src: '#offermodal' 
			  },
			  type: 'inline'
			});
		}, 3000); 
		createCookie("offerpopup", 'showofferpopup', 1);
		
	} */

